import { Typography, CircularProgress, Grid, Chip } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Wrapper } from "components/wrapper";
import { DetailCard, DetailField, DetailSectionTitle } from "components/detailPage";
import { ExportButtons } from "components/exportButtons";
import { useRepasseSetorialDetailsState } from "./context/repasse-setorial-details-context";
import { useRepasseSetorialDetailsController } from "./context/repasse-setorial-details-controller";

const formatCurrency = (value?: number | null) =>
  value !== undefined && value !== null
    ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '-';

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('pt-BR') : '-';

export function RepasseSetorialDetailsPage() {
  const { repasseSetorialDetails, loading, error } = useRepasseSetorialDetailsState();
  const { loadRepasseSetorialDetails, clearRepasseSetorialDetails, exportRepasseSetorialDetail } = useRepasseSetorialDetailsController();
  let { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (id) {
      loadRepasseSetorialDetails(parseInt(id));
    }

    return () => {
      clearRepasseSetorialDetails();
    };
  }, [id, loadRepasseSetorialDetails, clearRepasseSetorialDetails]);

  if (loading) {
    return (
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Typography color="error" variant="h6">{error}</Typography>
      </Wrapper>
    );
  }

  if (!repasseSetorialDetails) {
    return (
      <Wrapper>
        <Typography variant="h6">Repasse setorial não encontrado.</Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Repasses Setoriais", href: "/repasses-setoriais" },
          { label: `${repasseSetorialDetails.areaName} - ${repasseSetorialDetails.ano}` },
        ]}
      />
      <PageTitle>REPASSE {repasseSetorialDetails.areaName} - {repasseSetorialDetails.ano}</PageTitle>
      <Wrapper>
        <ExportButtons onExport={(format) => exportRepasseSetorialDetail(Number(id), format)} />
        <DetailCard>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Chip label={repasseSetorialDetails.origemName} color="primary" />
            </Grid>

            <Grid item xs={12} sm={4}>
              <DetailField label="Área" value={repasseSetorialDetails.areaName} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DetailField label="Exercício" value={String(repasseSetorialDetails.ano)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DetailField label="Data de Publicação" value={formatDate(repasseSetorialDetails.dtaPublicacao)} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Valores</DetailSectionTitle>
            </Grid>

            <Grid item xs={12} sm={6}>
              <DetailField label="Valor Previsto" value={formatCurrency(repasseSetorialDetails.valorPrevisto)} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DetailField label="Valor Realizado" value={formatCurrency(repasseSetorialDetails.valorRealizado)} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Descrição</DetailSectionTitle>
            </Grid>

            <Grid item xs={12}>
              <DetailField label="Descrição" value={repasseSetorialDetails.textoDescricao} />
            </Grid>
          </Grid>
        </DetailCard>
      </Wrapper>
    </>
  );
}
